import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import {
  createProjectApi,
  deleteProjectApi,
  getEditProjectApi,
  UpdateProjectApi,
  userListApi,
} from "../../api";
import { IPAuditMember } from "../../models/IPAuditMember";
import {
  createProjectRequest,
  deleteProjectRequest,
  getEditProjectRequest,
  initializeIPProject,
  IPProject,
  newIPProject,
  updateProjectRequest,
} from "../../models/IPProject";

import {
  initializeIPSchedule,
  initializeSchedule,
  IPSchedule,
} from "../../models/IPSchedule";

import {
  initializeKisaUser,
  KISAUser,
  KISAUserListRequest,
} from "../../models/KISAUser";

import IPUtility from "../../classes/IPUtility";
import { toastPopupOpenAction } from "./interactionReducer";
import { getProjectList } from "./projectListReducer";
import IPConstants from "../../classes/IPConstants";

export const getEditProject = createAsyncThunk(
  "/getEditProject",
  async (params: getEditProjectRequest) => {
    try {
      const requestParams: getEditProjectRequest = {
        userToken: params.userToken,
        id: params.id,
      };

      return await axios
        .post(getEditProjectApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);
export const createProject = createAsyncThunk(
  "/createProject",
  async (params: createProjectRequest, { dispatch }) => {
    try {
      const requestParams: createProjectRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      console.log(requestParams);
      return await axios
        .post(createProjectApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          console.log(data);
          if (
            data !== undefined &&
            data.message.indexOf(IPConstants.successMessage) > -1
          ) {
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트가 저장되었습니다.",
                severity: "info",
              })
            );
            if (params.successHandler) params.successHandler();
            const param = sessionStorage.getItem("projectListParams");
            if (param) dispatch(getProjectList(JSON.parse(param)))
          } else
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트 저장에 실패했습니다.",
                severity: "warning",
              })
            );
          return data;
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

export const updateProject = createAsyncThunk(
  "/updateProject",
  async (params: updateProjectRequest, { dispatch }) => {
    try {
      const requestParams: updateProjectRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(UpdateProjectApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (
            data !== undefined &&
            data.message.indexOf(IPConstants.successMessage) > -1
          ) {
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트가 업데이트 되었습니다.",
                severity: "info",
              })
            );
            if (params.successHandler) params.successHandler();
            const param = sessionStorage.getItem("projectListParams");
            if (param) dispatch(getProjectList(JSON.parse(param)))
          } else
            dispatch(
              toastPopupOpenAction({
                contents: "프로젝트 업데이트에 실패했습니다.",
                severity: "warning",
              })
            );
          return data;
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

export const getUserList = createAsyncThunk(
  "/userList",
  async (params: KISAUserListRequest) => {
    try {
      const requestParams: KISAUserListRequest = {
        userToken: params.userToken,
        page: params.page,
        rowCount: params.rowCount,
        searchWord: params.searchWord,
      };
      return await axios
        .post(userListApi, requestParams)
        .then((res) => res.data);
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

interface projectType {
  currentProject: IPProject;
  selectProject: IPProject;
  loading: boolean;
  error: string;
  maxPage: number;
  message: string;
  projectEditSwitch: boolean;
  addProjectSwitch: boolean;

  currentUid: number;
  searchWord: string;
  page: number;
  userList: KISAUser[];
  tableHeader: string[];
  // schedules: IPSchedule[];
  // auditMembers: IPAuditMember[];
  // participantsUsers: KISAUser[];
}
const initialState: projectType = {
  currentProject: {} as IPProject,
  selectProject: {} as IPProject,
  loading: true,
  error: "",
  maxPage: 0,
  message: "",
  projectEditSwitch: false,
  addProjectSwitch: false,
  currentUid: 0,
  searchWord: "",
  page: 0,
  userList: [],
  tableHeader: ["이름", "부서", "이메일", "편집"],
  // schedules: [] as IPSchedule[],
  // auditMembers: [] as IPAuditMember[],
  // participantsUsers: [] as KISAUser[],
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    modifyProjectAction: (state) => {
      state.projectEditSwitch = true;
      state.currentProject = state.selectProject;
    },

    createProjectAction: (state) => {
      state.projectEditSwitch = false;
      state.currentProject = { ...newIPProject() };
      state.currentProject.guid = IPUtility.generateUUID();
    },

    addAuditPlanAction: (state, { payload }: PayloadAction<IPSchedule>) => {
      const index = state.currentProject.schedules.findIndex(x => x.uuid === payload.uuid);
      if (index > -1) {
        // Update
        state.currentProject.schedules[index] = payload;
      }
      else {
        // Insert
        state.currentProject.schedules.push(payload);
      }
    },

    deleteAuditPlanAction: (state, { payload }: PayloadAction<any>) => {
      const deleteAuditPlan = state.currentProject.schedules.filter(
        (item) => item.uuid !== payload
      );
      state.currentProject.schedules = deleteAuditPlan;
    },

    changeAuditPlanAction: (state, { payload }: PayloadAction<IPSchedule[]>) => {
      state.currentProject.schedules = payload;
    },

    addAuditMemberAction: (state, { payload }: PayloadAction<IPAuditMember>) => {
      const index = state.currentProject.auditMembers.findIndex(x => x.uuid === payload.uuid);
      if (index > -1) {
        // Update
        state.currentProject.auditMembers[index] = payload;
      }
      else {
        // Insert
        state.currentProject.auditMembers.push(payload);
      }
    },

    deleteAuditMembersAction: (state, { payload }: PayloadAction<any>) => {
      const deleteAuditMember = state.currentProject.auditMembers.filter(
        (item) => item.uuid !== payload
      );
      state.currentProject.auditMembers = deleteAuditMember;
    },
    changeAuditMembersAction: (
      state,
      { payload }: PayloadAction<IPAuditMember[]>
    ) => {
      state.currentProject.auditMembers = payload;
    },

    addMemberAction: (state, { payload }: PayloadAction<number | null>) => {
      if (
        state.currentProject.participantsUsers.find(
          (member) => member.uid === payload
        )
      ) {
        return;
      } else {
        const addMember = state.userList.find(
          (member) => member.uid === payload
        );
        state.currentProject.participantsUsers = [
          ...state.currentProject.participantsUsers,
          addMember!,
        ];
        state.currentProject.participantsUIDs.push(addMember!.uid);
      }
    },
    deleteMemberAction: (state, { payload }: PayloadAction<number>) => {
      const deleteMember = state.currentProject.participantsUsers.filter(
        (member) => member.uid !== payload
      );
      state.currentProject.participantsUsers = deleteMember;
      const index = state.currentProject.participantsUIDs.indexOf(payload);
      if (index > -1) state.currentProject.participantsUIDs.splice(index, 1);
    },

    searchUserAction: (state, { payload }: PayloadAction<any>) => {
      if (payload.page === undefined) state.page = 1;
      if (payload.inputWord !== undefined) {
        state.searchWord = payload.inputWord;
        state.page = payload.page;
      } else {
        return;
      }
    },

    ReferenceProjectAction: (state) => {
      state.addProjectSwitch = true;
    },

    compareProjectAction: (state) => {
      state.addProjectSwitch = false;
    },

    addCompareProjectAction: (state, { payload }: PayloadAction<number>) => {
      if (state.currentProject.compareProjectUIDs === undefined) state.currentProject.compareProjectUIDs = [] as number[];
      state.currentProject.compareProjectUIDs.push(payload);
    },

    deleteCompareProjectAction: (state, { payload }: PayloadAction<number>) => {
      const deleteProject = state.currentProject.compareProjectUIDs.filter(
        (project) => project !== payload
      );
      state.currentProject.compareProjectUIDs = deleteProject;
    },

    searchCompareProjectAction: (state, { payload }: PayloadAction<any>) => {
      if (payload.page === undefined) state.page = 1;
      if (payload.inputWord !== undefined) {
        state.searchWord = payload.inputWord;
        state.page = payload.page;
      } else {
        return;
      }
    },
  },

  extraReducers: {
    [getEditProject.pending.type]: (state) => {
      state.loading = true;
    },
    [getEditProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.selectProject = action.payload.item;
      state.message = action.payload.message;
      console.log(state.currentProject);
    },
    [getEditProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [createProject.pending.type]: (state) => {
      state.loading = true;
    },
    [createProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    },
    [createProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [updateProject.pending.type]: (state) => {
      state.loading = true;
    },
    [updateProject.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    },
    [updateProject.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },

    [getUserList.pending.type]: (state) => {
      state.loading = true;
    },
    [getUserList.fulfilled.type]: (state, action) => {
      state.loading = false;
      state.userList = action.payload.items;
      state.maxPage = action.payload.maxPage;
      state.message = action.payload.message;
    },
    [getUserList.rejected.type]: (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    },
  },
});
export const {
  modifyProjectAction,
  createProjectAction,
  addAuditPlanAction,
  deleteAuditPlanAction,
  changeAuditPlanAction,
  addAuditMemberAction,
  deleteAuditMembersAction,
  changeAuditMembersAction,
  addMemberAction,
  deleteMemberAction,
  searchUserAction,
  ReferenceProjectAction,
  compareProjectAction,
  addCompareProjectAction,
  deleteCompareProjectAction,
  searchCompareProjectAction,
} = projectSlice.actions;

export default projectSlice.reducer;
